import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config
import UI_CUSTOMER_DETAILS_PAGE_QUERY from '@jira/servicedesk__customer-details/src/__generated__/CustomerDetailsCustomerDetailsPageQuery$parameters.ts';
import type { CustomerDetailsCustomerDetailsPageQuery } from '@jira/servicedesk__customer-details/src/__generated__/CustomerDetailsCustomerDetailsPageQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

export const CustomerDetailsPageQueryResource: RouteResource<
	PreloadedQuery<CustomerDetailsCustomerDetailsPageQuery, Record<string, unknown>>
> = createRelayResource<CustomerDetailsCustomerDetailsPageQuery>({
	type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: UI_CUSTOMER_DETAILS_PAGE_QUERY,
		variables: {
			accountId: String(match.params.customerId),
			cloudId: tenantContext.cloudId,
			csmCustomerNameUpdateMutationEnabled: fg('csm_customer_name_update_mutation'),
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
